var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileText1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.33317 1.33398H3.99984C3.64622 1.33398 3.30708 1.47446 3.05703 1.72451C2.80698 1.97456 2.6665 2.3137 2.6665 2.66732V13.334C2.6665 13.6876 2.80698 14.0267 3.05703 14.2768C3.30708 14.5268 3.64622 14.6673 3.99984 14.6673H11.9998C12.3535 14.6673 12.6926 14.5268 12.9426 14.2768C13.1927 14.0267 13.3332 13.6876 13.3332 13.334V5.33398L9.33317 1.33398Z",
    stroke: "#1A9ED0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.33325 1.33398V5.33398H13.3333",
    stroke: "#1A9ED0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6666 8.66699H5.33325",
    stroke: "#1A9ED0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.6666 11.334H5.33325",
    stroke: "#1A9ED0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.66659 6H5.99992H5.33325",
    stroke: "#1A9ED0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileText1);
export default __webpack_public_path__ + "static/media/file-text (1).9397752fbe314eab68962848b5c072d2.svg";
export { ForwardRef as ReactComponent };